module.exports = __webpack_public_path__ + "static/img/Works_bak.a7eac00.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Works_bak.jpg
// module id = SVLU
// module chunks = 1